import { useState, useEffect } from 'react'
import Header from '../Components/Header'
import LeftComponent from '../Components/LeftComponent'
import RightCompoent from '../Components/RightCompoent'
import Footer from '../Components/Footer';
import { getAllProducts } from '../services/forecastService.js';
import { transformProductData } from '../utils/transformProductData.js';

function MainPage() {
    const [selectedItemName, setSelectedItemName] = useState(null); // or use selectedItemId
    const [isSingleModel, setIsSingleModel] = useState(null);
    const [sopData, setSopData] = useState(null); // or use selectedItemId
    const [allProductCategories, setAllProductCategories] = useState([]);
    const [allProduct, setAllProduct] = useState([]);

    useEffect(() => {
        getAllProducts()
            .then((res) => {
                const rawData = res.data;
                console.log('rawData', rawData);


                const structured = transformProductData(rawData);
                setAllProduct(structured['menu']);
                console.log('structured : ', structured['menu'], structured['sop_data']);


                const productCategories = structured['menu'].map(obj => ({ id: obj.id, name: obj.name }));
                setAllProductCategories(productCategories);
                setSopData(structured['sop_data']);
            })
            .catch((err) => {
                console.error("Error fetching product list:", err);
            });

        return () => {
            setAllProduct([])
        }
    }, []);

    const handleLeafClick = (item) => {
        setSelectedItemName(item?.modelCode ?? item?.name);
        setIsSingleModel(item?.isLeaf)
    };

    return (
        <div data-testid="main-page" className='flex flex-col h-screen' style={{ backgroundColor: '#F4F4F5' }}>
            <Header />
            <div className="flex flex-no-wrap" style={{ flex: "2" }}>
                <div
                    data-testid="sidebar-panel"
                    className="w-72 absolute mt-0 sm:relative bg-white md:h-full flex-col justify-between hidden sm:flex border-r"
                    style={{
                        minHeight: '550px',
                        borderColor: '#E4E4E7',
                        backgroundColor: '#FAFAFA'
                    }}
                >
                    <LeftComponent onLeafNodeClick={handleLeafClick} selectedItemName={selectedItemName} allProduct={allProduct} allProductCategories={allProductCategories} />
                </div>
                <div
                    data-testid="main-content-panel"
                    className="mx-auto py-4 h-full md:w-[82%] w-11/12 px-4"
                >
                    <RightCompoent selectedItemName={selectedItemName} isSingleModel={isSingleModel} sopData={sopData} />
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default MainPage
